import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import JobMap, { useGeocodedJobs } from "@/components/JobMap";
import { fmtTime } from "@/lib/helpers";
import { ArrowLeft, Loader2 } from "lucide-react";
import { DroneIcon } from "@/components/DroneIcon";

const bneDay = (iso) => { try { return new Date(iso).toLocaleDateString("en-CA", { timeZone: "Australia/Brisbane" }); } catch { return ""; } };

export default function TodayMapPage({ fullscreen = false }) {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs").then((r) => {
      const today = new Date().toLocaleDateString("en-CA", { timeZone: "Australia/Brisbane" });
      const todays = r.data.filter((j) => bneDay(j.start) === today && j.location);
      setJobs(todays.map((j) => ({ id: j.id, title: j.title, location: j.location, time: fmtTime(j.start) })));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const points = useGeocodedJobs(jobs);

  return (
    <div className={fullscreen ? "h-screen w-screen flex flex-col bg-slate-900" : "space-y-4 fade-up"}>
      <div className={fullscreen ? "flex items-center justify-between px-5 h-14 bg-slate-900 text-white shrink-0" : "flex items-center justify-between"}>
        <div className="flex items-center gap-2">
          {fullscreen && <DroneIcon className="h-6 w-6 text-lime-400" />}
          <h1 className={fullscreen ? "font-heading font-bold text-lg text-white" : "text-2xl font-bold font-heading text-slate-900"}>
            Today's Jobs Map <span className="text-lime-500">({jobs.length})</span>
          </h1>
        </div>
        {fullscreen
          ? <button onClick={() => window.close()} className="text-slate-300 hover:text-white text-sm">Close</button>
          : <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900"><ArrowLeft className="h-4 w-4" /> Back</button>}
      </div>
      {loading
        ? <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-lime-500" /></div>
        : <JobMap points={points} height={fullscreen ? "100%" : "70vh"} className={fullscreen ? "flex-1 rounded-none border-0" : ""} />}
    </div>
  );
}
